<!-- 商品列表 -->

<template>
  <div :style="css">
    <div class="container good_list_box" :style="'grid-template-columns: repeat(' +
    columnNum +
    ', 1fr);' +
    'width:' +
    width1 +
    'px !important;' +
    listCss
    ">
      <div class="good_box" v-for="(item, index) in goodList" :key="index" @click="toGoodDetail(item, 0)">
        <div class="img_box">
          <img :src="item.thumbnailCommon" alt="" />
        </div>
        <div class="info_box" v-if="type == 1">
          <div class="line_box">
            <span>product name</span>
            <span>{{ item.name || "" }}</span>
          </div>
          <div class="line_box">
            <span>Coil</span>
            <span>{{ item.smokeType || "" }}</span>
          </div>
          <div class="line_box">
            <span>E-Liquid</span>
            <span>{{ item.capacity || "" }}</span>
          </div>
          <div class="line_box">
            <span>Puffs</span>
            <span>{{ item.smokeNum || "" }}</span>
          </div>
          <!-- <div class="line_box">
            <span>nicotine content</span>
            <span>{{ item.smokeNum || "" }}</span>
          </div> -->
          <div class="line_box">
            <span>battery</span>
            <span>{{ item.battery }}</span>
          </div>
          <div class="car_box">
            <span>$</span>
            <span class="num">{{ item.price }}</span>
            <div v-loading="item.loading">
              <img @click.stop="openSelectSkuAddCar(item)" src="@/assets/images1/25.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  选择规格加入购物车  -->
    <SelectSkuAddCar ref="selectSkuAddCar" />
  </div>
</template>

<script>
export default {
  props: {
    css: String,
    /** 商品列表 */
    goodList: {
      type: Array,
      default() {
        return [];
      },
    },
    // type为1则显示商品文字信息 type为2或其他则不显示
    type: {
      type: Number,
      default: 1,
    },
    /** 列表列数 */
    columnNum: { type: Number, default: 5 },
    /** 宽度 */
    width1: { type: Number, default: 1380 },
    /** 列表样式 */
    listCss: String,
    denglu: false,
  },
  data() {
    return {};
  },
  mounted() {
    var token = localStorage.getItem("TIANYUE_TOKEN");
    if (!token) {
      this.denglu = true;
      this.hideContentForGuest();
    }
  },
  methods: {
    /** 加入购物车 */
    addCar(info = {}) {
      if (info.loading) return;
      info.loading = true;
      this.$post("system/cart", {
        goodsId: info.goodsId, //商品id
        number: 1, //数量
        falvorId: info.firstFlavors.falvorId, //口味id
        nicotineId: info.firstNicotine.nicotineId, //尼古丁id
      })
        .then((res) => {
          this.$msg((res || {}).msg || "succeed");
        })
        .catch((err) => {
          this.$msg((err || {}).msg || "加入购物车fail");
        })
        .finally((_) => (info.loading = false));
    },
    hideContentForGuest() {
      const numElements = document.querySelectorAll(".num");
      numElements.forEach((element) => {
        element.textContent = "***";
      });
    },
    openSelectSkuAddCar(item) {
      let token = localStorage.getItem("TIANYUE_TOKEN");
      if (token) {
        this.$refs.selectSkuAddCar.open(item);
      } else {
        this.$router.push('/login');
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.good_list_box {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-column-gap: 40px;
  grid-row-gap: 40px;

  .good_box {
    // height: 458px;
    background: #ffffff;
    border-radius: 16px;
    box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.08);

    .img_box {
      height: 258px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;

      img {
        width: 88%;
        height: 236px;
        border-radius: 4px;
      }
    }

    .info_box {
      padding: 24px 24px;
      font-size: 14px;
      font-family: Inter, Inter-400;
      font-weight: 400;
      text-align: LEFT;
      color: #12181d;
      line-height: 16px;

      .line_box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 12px;

        &:first-of-type {
          margin-top: 0;
        }
      }

      .car_box {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-family: Inter, Inter-500;
        font-weight: 500;
        text-align: LEFT;
        color: #fa14d5;
        line-height: 19px;
        cursor: pointer;
        width: max-content;
        margin: 16px auto 0;

        img {
          width: 32px;
          height: 32px;
          margin-left: 12px;
        }

        .num {
          font-size: 20px;
          line-height: 23px;
        }
      }
    }
  }
}
</style>
